import { GetClientPlanResponse } from '../clientContracts/plan/planDTO';
import { User } from '../types/client';

export const isBillingOnlyUser = (clientUser: User, clientPlan?: GetClientPlanResponse) => {
    return (
        (clientUser.activeClient.userClients.userType === 'user' &&
            clientUser.activeClient.billingOnly &&
            (clientUser.activeClient.userClients.role === 'user' ||
                clientUser.activeClient.userClients.role === 'admin')) ||
        clientPlan?.status === 'SUSPENDED'
    );
};

/**
 * Determines if a user is an internal user based on user context
 * @param userContext - The user context object
 * @returns boolean indicating if user is internal
 */
export const checkIfUserIsInternal = (userContext: User): boolean => {
    if (!userContext?.activeClient?.userClients) {
        return false;
    }

    const { userType, role } = userContext.activeClient.userClients;
    return userType === 'user' && role?.includes('internal');
};

/**
 * Gets user role from context
 * @param userContext - The user context object
 * @returns user role string or null
 */
export const getUserRole = (userContext: User): string | null => {
    return userContext?.activeClient?.userClients?.role || null;
};

/**
 * Gets user type from context
 * @param userContext - The user context object
 * @returns user type string or null
 */
export const getUserType = (userContext: User): string | null => {
    return userContext?.activeClient?.userClients?.userType || null;
};
